import React from "react";
import styled from "styled-components";

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 3rem 1rem;
  width: 100%;
  background: transparent;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 4rem 3rem;
    gap: 4rem;
  }
`;

const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 600px;
  width: 100%;

  img {
    width: 100%;
    height: auto;
    max-height: 450px;
    object-fit: contain;
  }
`;

const AchievementsText = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.5rem;
  text-align: center;

  @media (min-width: 768px) {
    text-align: left;
    align-items: flex-start;
  }
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.greenLight};
  font-size: clamp(2rem, 5vw, 3.5rem);
  line-height: 1.2;
`;

const Subtitle = styled.p`
  font-size: clamp(1rem, 2vw, 1.5rem);
  color: ${({ theme }) => theme.blue8};
  max-width: 500px;
`;

const StatGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
  width: 100%;
`;

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.blue8};

  &:last-child {
    border-bottom: none;
  }
`;

const StatTitle = styled.span`
  font-size: 1rem;
  color: ${({ theme }) => theme.blue8};
  margin-bottom: 0.25rem;
`;

const StatValue = styled.h3`
  font-size: clamp(1.5rem, 4vw, 3rem);
  color: ${({ theme }) => theme.black};
  font-weight: bold;
`;

const Achievements = () => (
  <Container>
    <ImageContainer>
      <img src="/assets/img/PNG/Landing_pic2.svg" alt="Achievements graphic" />
    </ImageContainer>
    <AchievementsText>
      <Title>Achievements</Title>
      <Subtitle>Helping thousands of customers achieve their goals</Subtitle>
      <StatGroup>
        <Stat>
          <StatTitle>Total Payment Sent</StatTitle>
          <StatValue>1000M+</StatValue>
        </Stat>
        <Stat>
          <StatTitle>Total Users</StatTitle>
          <StatValue>50K+</StatValue>
        </Stat>
        <Stat>
          <StatTitle>Companies</StatTitle>
          <StatValue>5K+</StatValue>
        </Stat>
      </StatGroup>
    </AchievementsText>
  </Container>
);

export default Achievements;
